import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/3d-game/banner_threed.webp";

function Banner(props) {
  // Function to handle the scroll action
  const scrollToCaseStudies = () => {
    const caseBtnElement = document.getElementById("case_btn");
    if (caseBtnElement) {
      // Using `scrollIntoView` to scroll to the target element
      caseBtnElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_cost_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={8} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                3D Game Development Company
              </h1>
              <span>
                <span style={{ color: "#f47a14" }}>TekRevol</span>: Leading the
                Future of 3D Mobile Game Development
              </span>
              <p style={{ marginTop: "10px" }}>
                TekRevol is a leading 3D game development company that produces
                modern and attractive 2D and 3D games on iOS and Android. The
                content of our games includes highly detailed graphics,
                well-coordinated gameplay actions, and compelling plots that are
                difficult to find in other mobile games.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Discuss Your Game Idea
              </Link>
              <button
                className="border_btn web_case_btn"
                aria-label="TekRevol Contact"
                onClick={scrollToCaseStudies}
              >
                Case Studies
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
